import React, { useState, Suspense } from 'react';
import Modal from './modal';
import Loading from 'components/loading';

type TermsDialogProps = {
    id?: string;
    label?: string;
    title: string;
    className?: string;
};

const TermsDialog: React.FC<TermsDialogProps> = ({ id, label, title, className, children }) => {
    const [opened, setOpened] = useState(false);

    return (
        <>
            <a id={id} className={className} onClick={() => setOpened(true)}>{label}</a>

            <Modal
                visible={opened}
                title={title}
                onClose={() => setOpened(false)}
            >
                <Suspense fallback={<Loading />}>
                    {children}
                </Suspense>
            </Modal>
        </>
    );
};

export default TermsDialog;
